var base_url = 'admin.180dcusyd.org'


export const proj_confs = {
    base: base_url,
    root: `https://${base_url}`,
    ws: `wss://${base_url}`,
};